import React from 'react'
// libs
import styled from 'styled-components'
// types
import { Widget } from 'store/reducers/dashboards'

const ImagePlaceholder = styled.div`
  min-height: 100px;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
`

const StyledImage = styled.img<{ height: number }>`
  width: auto;
  max-width: 100%;
  height: ${({ height }) => height}px;
  border-radius: 6px;
`

interface Props {
  data: Widget
}

const Image: React.FC<Props> = ({ data }) => {
  const { height, imageUrl, imageFilename } = data.item.settings

  if (imageUrl) {
    return <StyledImage src={imageUrl} height={height} alt={imageFilename} />
  }

  return <ImagePlaceholder />
}

export default Image
